/**
 * Store Locations Constants for TuTiMi Application
 * Contains all store location data including addresses, contact info, and operating hours
 */

export interface StoreLocation {
  id: number
  name: string
  address: string
  phone: string
  hours: string
}

export interface StoreLocationsByArea {
  [area: string]: StoreLocation[]
}

/**
 * Store Locations Grouped by District/Area
 * Organized for interactive area selection in Footer component
 * Updated with actual TuTiMi store data
 */ export const STORE_LOCATIONS_BY_AREA: StoreLocationsByArea = {
  "Quận 3": [
    {
      id: 17,
      name: "Cách Mạng Tháng Tám",
      address: "376D Cách Mạng Tháng Tám, P. 10, Q. 3, Thành phố Hồ Chí Minh",
      phone: "0327725382",
      hours: "6h-23h",
    },
  ],
  "Quận 4": [
    {
      id: 23,
      name: "Vĩnh Hội",
      address: "98 Vĩnh Hội, P. 4, Q. 4, Thành phố Hồ Chí Minh",
      phone: "0921541250",
      hours: "6h-23h",
    },
  ],
  "Quận 7": [
    {
      id: 25,
      name: "Tân Kiểng",
      address: "26 Đường Số 17, P. Tân Kiểng, Q. 7, Thành phố Hồ Chí Minh",
      phone: "0364490195",
      hours: "6h-23h",
    },
    {
      id: 30,
      name: "Bùi Văn Ba",
      address: "55 Bùi Văn Ba, P. Tân Thuận, Q. 7, Thành phố Hồ Chí Minh",
      phone: "0364490195",
      hours: "6h-23h",
    },
  ],
  "Quận 8": [
    {
      id: 27,
      name: "Đặng Chất",
      address: "45 Đặng Chất, P. 3, Q. 8, Thành phố Hồ Chí Minh",
      phone: "0949847726",
      hours: "6h-23h",
    },
  ],
  "Quận 10": [
    {
      id: 22,
      name: "Nguyễn Tri Phương",
      address: "372 Nguyễn Tri Phương, P. 4, Q. 10, Thành phố Hồ Chí Minh",
      phone: "0934794164",
      hours: "6h-23h",
    },
  ],
  "Quận 12": [
    {
      id: 10,
      name: "71A Nguyễn Văn Quá",
      address:
        "71A Nguyễn Văn Quá, P. Tân Hưng Thuận, Q. 12, Thành phố Hồ Chí Minh",
      phone: "0395171510",
      hours: "6h-23h",
    },
    {
      id: 32,
      name: "Nguyễn Ảnh Thủ",
      address: "34 Nguyễn Ảnh Thủ, P. Hiệp Thành, Q. 12, Thành phố Hồ Chí Minh",
      phone: "0395171510",
      hours: "6h-23h",
    },
  ],
  "Bình Thạnh": [
    {
      id: 1,
      name: "Bình Quới",
      address: "129A Bình Quới, P. 27, Q. Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0707903937",
      hours: "6h-23h",
    },
    {
      id: 5,
      name: "Ngô Tất Tố",
      address: "71 Ngô Tất Tố, P. 21, Q. Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0708916541",
      hours: "6h-23h",
    },
    {
      id: 7,
      name: "Vạn Kiếp",
      address: "200 Vạn Kiếp, P. 3, Q. Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0396809945",
      hours: "6h-23h",
    },
    {
      id: 12,
      name: "Đặng Thùy Trâm",
      address:
        "39/50 Đặng Thùy Trâm, P. 13, Q. Bình Thạnh, Thành phố Hồ Chí Minh",
      phone: "0823684518",
      hours: "6h-23h",
    },
  ],
  "Tân Bình": [
    {
      id: 9,
      name: "Đồng Đen",
      address: "39 Đồng Đen, P. 12, Q. Tân Bình, Thành phố Hồ Chí Minh",
      phone: "0398572592",
      hours: "6h-23h",
    },
    {
      id: 11,
      name: "Lạc Long Quân",
      address: "712 Lạc Long Quân, P. 9, Q. Tân Bình, Thành phố Hồ Chí Minh",
      phone: "0377920938",
      hours: "6h-23h",
    },
    {
      id: 19,
      name: "Trường Sơn",
      address: "65 Trường Sơn, P. 2, Q. Tân Bình, Thành phố Hồ Chí Minh",
      phone: "0327725382",
      hours: "6h-23h",
    },
  ],
  "Gò Vấp": [
    {
      id: 3,
      name: "Đường số 8",
      address: "202 Đường Số 8, P. 11, Q. Gò Vấp, Thành phố Hồ Chí Minh",
      phone: "0386179601",
      hours: "6h-23h",
    },
    {
      id: 4,
      name: "Phan Văn Trị",
      address: "711 Phan Văn Trị, P. 7, Q. Gò Vấp, Thành phố Hồ Chí Minh",
      phone: "0386179601",
      hours: "6h-23h",
    },
  ],
  "Phú Nhuận": [
    {
      id: 2,
      name: "Nguyễn Kiệm",
      address: "376 Nguyễn Kiệm, P. 3, Q. Phú Nhuận, Thành phố Hồ Chí Minh",
      phone: "0396809945",
      hours: "6h-23h",
    },
  ],
  "Tân Phú": [
    {
      id: 8,
      name: "Tân Quý",
      address: "34C Tân Quý, P. Tân Quý, Q. Tân Phú, Thành phố Hồ Chí Minh",
      phone: "0398572592",
      hours: "6h-23h",
    },
  ],
  "Bình Tân": [
    {
      id: 14,
      name: "Tỉnh Lộ 10",
      address: "329 Tỉnh Lộ 10, P. An Lạc, Q. Bình Tân, Thành phố Hồ Chí Minh",
      phone: "0565232814",
      hours: "6h-23h",
    },
    {
      id: 24,
      name: "Lê Văn Quới",
      address:
        "572 Lê Văn Quới, P. Bình Hưng Hòa A, Q. Bình Tân, Thành phố Hồ Chí Minh",
      phone: "0565232814",
      hours: "6h-23h",
    },
    {
      id: 29,
      name: "Hồ Học Lãm",
      address: "486A Hồ Học Lãm, P. An Lạc, Q. Bình Tân, Thành phố Hồ Chí Minh",
      phone: "0565232814",
      hours: "6h-23h",
    },
  ],
  "Bình Chánh": [
    {
      id: 31,
      name: "Quốc Lộ 50",
      address:
        "637 Quốc Lộ 50, X. Bình Hưng, H. Bình Chánh, Thành phố Hồ Chí Minh",
      phone: "0934794164",
      hours: "6h-23h",
    },
  ],
  "Thủ Đức": [
    {
      id: 15,
      name: "Hiệp Bình",
      address:
        "77A - 77B Hiệp Bình, P. Hiệp Bình Phước, TP. Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0708916541",
      hours: "6h-23h",
    },
    {
      id: 16,
      name: "Nguyễn Duy Trinh",
      address:
        "168A Nguyễn Duy Trinh, P. Bình Trưng Tây, TP. Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0974613131",
      hours: "6h-23h",
    },
    {
      id: 18,
      name: "Đường Số 17, Thủ Đức",
      address:
        "38A Đường Số 17, P. Linh Chiểu, TP. Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0963858722",
      hours: "6h-23h",
    },
    {
      id: 20,
      name: "Đỗ Xuân Hợp",
      address:
        "275 Đỗ Xuân Hợp, P. Phước Long B, TP. Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0974613131",
      hours: "6h-23h",
    },
    {
      id: 21,
      name: "Đường Số 3",
      address: "59 Đường Số 3, P. An Khánh, TP. Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0708916541",
      hours: "6h-23h",
    },
    {
      id: 26,
      name: "Man Thiện",
      address: "45 Man Thiện, P. Hiệp Phú, TP. Thủ Đức, Thành phố Hồ Chí Minh",
      phone: "0963858722",
      hours: "6h-23h",
    },
  ],
  "Hóc Môn": [
    {
      id: 13,
      name: "Quang Trung",
      address: "1/3 Quang Trung, TT Hóc Môn, H. Hóc Môn, Thành phố Hồ Chí Minh",
      phone: "0785779488",
      hours: "6h-23h",
    },
  ],
}
